import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";

export const ProfileRoute: ViewRoute = {
  [RouteNames.profile]: () => {
    return RouteNames.drinkFrequency;
  }
};
